module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo05-b7d4872f6ac99f456ccb195ae496239d.jpg";